export default __webpack_public_path__ + "static/media/imagem_edr.7b72549b.png";